import { NotificationActionTypesEnum } from 'types/generated/client';
import CompleteReflectionForCoachNotification from './CompleteReflectionForCoachNotification';
import ConnectionNotification from './ConnectionNotification';
import CourtBookingNotification from './CourtBookingNotification';
import GameInviteNotification from './GameInviteNotification';
import GroupCommentSubmittedNotification from './GroupCommentSubmittedNotification';
import GroupCommentUpvotedNotification from './GroupCommentUpvotedNotification';
import LessonCoachCancelNotification from './LessonCoachCancelNotification';
import LessonParticipantJoinNotification from './LessonParticipantJoinNotification';
import LessonParticipantLeaveNotification from './LessonParticipantLeaveNotification';
import LessonStartReminderNotification from './LessonStartReminderNotification';
import NewReflectionForPlayerNotification from './NewReflectionForPlayerNotification';
import PlayRequestNotification from './PlayRequestNotification';
import PlaySessionCommentNotification from './PlaySessionCommentNotification';
import PlaySessionOrganizerCancelNotification from './PlaySessionOrganizerCancelNotification';
import PlaySessionParticipantJoinNotification from './PlaySessionParticipantJoinNotification';
import PlaySessionParticipantLeaveNotification from './PlaySessionParticipantLeaveNotification';
import PlaySessionStartReminderNotification from './PlaySessionStartReminderNotification';
import PlaySessionUpdatedNotification from './PlaySessionUpdatedNotification';
import ReviewLessonNotification from './ReviewLessonNotification';
import TournamentPartnerRequestReceivedNotification from './TournamentPartnerRequestReceivedNotification';
import VideoAnalysisCompletePlayerNotification from './VideoAnalysisCompletePlayerNotification';
import VideoAnalysisForCoachNotification from './VideoAnalysisForCoachNotification';
import VideoAnalysisForPlayerNotification from './VideoAnalysisForPlayerNotification';
import { NotificationTypeSelectorProps } from '../types';

export default function NotificationTypeSelector({ notification }: NotificationTypeSelectorProps) {
  const notificationDetails = notification.notificationDetails;
  const actionType = notificationDetails.actionType;

  if (actionType === NotificationActionTypesEnum.LessonCoachCancel) {
    return (
      <LessonCoachCancelNotification
        notification={notification}
        status={notification.status}
        lesson={notification.notificationDetails.primaryEntity.lesson}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.LessonParticipantLeave) {
    return (
      <LessonParticipantLeaveNotification
        notification={notification}
        status={notification.status}
        lesson={notification.notificationDetails.primaryEntity.lesson}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.LessonParticipantJoin) {
    return (
      <LessonParticipantJoinNotification
        notification={notification}
        status={notification.status}
        lesson={notification.notificationDetails.primaryEntity.lesson}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.LessonStartReminder) {
    return (
      <LessonStartReminderNotification
        notification={notification}
        status={notification.status}
        lesson={notification.notificationDetails.primaryEntity.lesson}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionOrganizerCancel) {
    return (
      <PlaySessionOrganizerCancelNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionParticipantLeave) {
    return (
      <PlaySessionParticipantLeaveNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionParticipantJoin) {
    return (
      <PlaySessionParticipantJoinNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionStartReminder) {
    return (
      <PlaySessionStartReminderNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionCommentSubmit) {
    return (
      <PlaySessionCommentNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.PlaySessionDetailsUpdate) {
    return (
      <PlaySessionUpdatedNotification
        notification={notification}
        status={notification.status}
        playSession={notification.notificationDetails.primaryEntity.playSession}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.GroupCommentUpvote) {
    return (
      <GroupCommentUpvotedNotification
        notification={notification}
        status={notification.status}
        group={notification.notificationDetails.primaryEntity.group}
        groupThread={notification.notificationDetails.primaryEntity.groupThread}
      />
    );
  }
  if (actionType === NotificationActionTypesEnum.GroupCommentReply) {
    return (
      <GroupCommentSubmittedNotification
        notification={notification}
        status={notification.status}
        group={notification.notificationDetails.primaryEntity.group}
        groupThread={notification.notificationDetails.primaryEntity.groupThread}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.VideoAnalysisCompletePlayer) {
    return (
      <VideoAnalysisCompletePlayerNotification
        notification={notification}
        status={notification.status}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.VideoSubmissionNotificationCoach) {
    return (
      <VideoAnalysisForCoachNotification notification={notification} status={notification.status} />
    );
  }

  if (actionType === NotificationActionTypesEnum.VideoSubmissionConfirmPlayer) {
    return (
      <VideoAnalysisForPlayerNotification
        notification={notification}
        status={notification.status}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.NewReflectionForPlayer) {
    return (
      <NewReflectionForPlayerNotification
        notification={notification}
        status={notification.status}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.CompleteReflectionForCoach) {
    return (
      <CompleteReflectionForCoachNotification
        notification={notification}
        status={notification.status}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.ReviewCoachNotification) {
    return <ReviewLessonNotification notification={notification} status={notification.status} />;
  }

  if (
    actionType === NotificationActionTypesEnum.PlayRequestReceived ||
    actionType === NotificationActionTypesEnum.PlayRequestAccepted ||
    actionType === NotificationActionTypesEnum.PlayRequestDeclined ||
    actionType === NotificationActionTypesEnum.PlayRequestAutoCancelled
  ) {
    return (
      <PlayRequestNotification
        notification={notification}
        status={notification.status}
        actionType={actionType}
      />
    );
  }

  if (
    actionType === NotificationActionTypesEnum.CourtBookingConfirmed ||
    actionType === NotificationActionTypesEnum.CourtBookingFailed
  ) {
    return (
      <CourtBookingNotification
        notification={notification}
        status={notification.status}
        actionType={actionType}
        order={notification.notificationDetails.primaryEntity.partnerBookingOrder}
      />
    );
  }

  if (
    actionType === NotificationActionTypesEnum.ConnectionRequestReceived ||
    actionType === NotificationActionTypesEnum.ConnectionRequestAccepted
  ) {
    return (
      <ConnectionNotification
        notification={notification}
        status={notification.status}
        actionType={actionType}
      />
    );
  }

  if (
    actionType === NotificationActionTypesEnum.GameInviteReceived ||
    actionType === NotificationActionTypesEnum.GameInviteAccepted ||
    actionType === NotificationActionTypesEnum.GameInviteDeclined
  ) {
    return (
      <GameInviteNotification
        notification={notification}
        status={notification.status}
        actionType={actionType}
      />
    );
  }

  if (actionType === NotificationActionTypesEnum.TournamentPartnerRequestReceived) {
    return (
      <TournamentPartnerRequestReceivedNotification
        notification={notification}
        status={notification.status}
      />
    );
  }

  return null;
}
